import { OUTPUT_TTL } from '../../../constants/Pac';

const MIXER_ON_OFF_TIME = '2000';

/**
 * Mixer On/Off
 *
 * @param batchStore
 * @param mixer
 * @param {boolean} turnOn
 */
export const mixerSwitch = (batchStore, mixer, turnOn = true) => {
  if (!mixer?.mixerOnPNo) {
    return;
  }

  const mixerStatus = batchStore.getDeviceStatus(mixer.id);

  batchStore.deviceStatus.set(mixer.id, {
    ...mixerStatus,
    active: turnOn,
  });

  if (mixer.mixerOffPNo) {
    if (turnOn) {
      batchStore.setOutput(mixer.mixerOnPNo, MIXER_ON_OFF_TIME);
    } else {
      batchStore.setOutput(mixer.mixerOffPNo, MIXER_ON_OFF_TIME);
    }
  } else {
    batchStore.setOutput(mixer.mixerOnPNo, turnOn ? OUTPUT_TTL : '0');
  }

};
